module.exports = __webpack_public_path__ + "img/main.9cc22090.jpg";